import { ColDef } from 'ag-grid-community'
import { StatusIndicator } from '@amzn/awsui-components-react'
import { ITextFilterParams } from '@amzn/ag-bird/src/ag-grid-enterprise'
import { convertToLocalTime } from '../../common/Util'
import { STATUS_INDICATOR_TYPES } from '../../Constant'
import DatePopover from '../reusable/DatePopover'
import { FILTER_TYPE, DATA_TYPE } from './Constants'

const numberFilterValueGetter = (colDef) => {
    return (params) => {
        const value = params.getValue(colDef.field)
        if (value == null || value === '') return null
        const numberValue = Number(value)
        return isNaN(numberValue) ? null : numberValue
    }
}
const dateFilterValueGetter = (colDef) => {
    return (params) => {
        let dateAsString = params.getValue(colDef.field)
        if (dateAsString == null) return null

        try {
            const date = new Date(dateAsString)
            if (isNaN(date.getTime())) return null

            const isUTCString = (str) => str.endsWith('Z') || /[+-]\d{2}:\d{2}$/.test(str)
            if (isUTCString(dateAsString)) {
                return new Date(date.getFullYear(), date.getMonth(), date.getDate())
            }

            const dateParts = dateAsString.split('T')[0].split('-')
            const year = Number(dateParts[0])
            const month = Number(dateParts[1]) - 1
            const day = Number(dateParts[2])
            return new Date(year, month, day)
        } catch {
            return null
        }
    }
}
const filterGetters = {
    [FILTER_TYPE.NUMBER]: numberFilterValueGetter,
    [FILTER_TYPE.DATE]: dateFilterValueGetter,
}

const generateFilterParams = (colDef, params) => {
    switch (colDef.cellDataType) {
        case DATA_TYPE.BOOLEAN:
            return params.value ? 'Yes' : 'No'
        default:
            return params.value
    }
}

export const addGeneralFilterParams = (colDef: ColDef) => {
    colDef.menuTabs = ['generalMenuTab', 'columnsMenuTab']
    colDef.suppressColumnsToolPanel = colDef.hide
    colDef.floatingFilter = true
    colDef.filter = colDef.filter ?? FILTER_TYPE.SET
    colDef.filterValueGetter = filterGetters[colDef.filter]?.(colDef)
    colDef.filterParams = {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
        valueFormatter: (params) => {
            if (colDef.filter === FILTER_TYPE.SET) {
                return generateFilterParams(colDef, params)
            }
        },
    } as ITextFilterParams
}

export const dashFallbackRenderer = (params) => params.value || '-'
export const dateCellRenderer = (params) => <DatePopover date={convertToLocalTime(params.value)} />
export const booleanCellRenderer = (params) => (
    <StatusIndicator
        type={params.value ? STATUS_INDICATOR_TYPES.SUCCESS : STATUS_INDICATOR_TYPES.WARNING}
    >
        {params.value ? 'Yes' : 'No'}
    </StatusIndicator>
)
